var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Accordion",class:{opened: _vm.opened}},[_c('Button',{on:{"click":_vm.toggleAccordion}},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('span',[_vm._v("+")])]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.description)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }